import React, { useEffect } from "react"
import OrderProgressiveLoading from "@/components/Shared/OrderHistory/v1/OrderProgressiveLoading"
import PageLoader from "@/components/core/PageLoader/PageLoader"

import AccountsLayout from "@/components/AccountsLayout/AccountsLayout"
import useGenerici18n from "@/i18n/useGeneric"

const MyGenericFiller = ({ data: componentProps, title }) => {
  const staticTexts = useGenerici18n({
    componentProps,
  })
  useEffect(() => {
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    })
  }, [])
  return (
    <AccountsLayout
      title={staticTexts?.[title]}
      staticTexts={staticTexts}
      i18n={staticTexts}
      accountLayoutLoader={true}
    >
      <PageLoader loading={true} />
      <OrderProgressiveLoading />
    </AccountsLayout>
  )
}

export default MyGenericFiller
